import { render } from "./OurClients.vue?vue&type=template&id=65f6abe7"
import script from "./OurClients.vue?vue&type=script&lang=js"
export * from "./OurClients.vue?vue&type=script&lang=js"

import "./OurClients.vue?vue&type=style&index=0&id=65f6abe7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__